import store from '@/store'

export default [
  {
    path: '/admin/game-bettings',
    name: 'game-betting',
    meta: { requiresAuth: true },
    component: () => import('@/pages/game/game-betting')
  },
  {
    path: '/admin/game-bettings/create',
    name: 'game-betting-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/game/game-betting/create')
  }
]
